// PriceCharting hosts each product image at multiple sizes under the same path
// (/60.jpg, /240.jpg, /1600.jpg) but not every size exists for every image. We store the raw
// URL and upgrade it client-side, falling back down the chain on 404 - zero server requests.
const PC_HOST = "images.pricecharting.com";
const SIZES = ["1600", "240", "60"];

export function pcImageUrl(url, size = "240") {
  if (!url || !url.includes(PC_HOST)) return url;
  return url.replace(/\/\d+\.jpg$/, `/${size}.jpg`);
}

export function pcImageFallback(e) {
  const src = e.target.src || "";
  if (!src.includes(PC_HOST)) return;
  const match = src.match(/\/(\d+)\.jpg$/);
  if (!match) return;
  const idx = SIZES.indexOf(match[1]);
  if (idx >= 0 && idx < SIZES.length - 1) {
    e.target.src = src.replace(/\/\d+\.jpg$/, `/${SIZES[idx + 1]}.jpg`);
  }
}
